import { useTranslate } from '@tolgee/react'
import { cva, VariantProps } from 'class-variance-authority'
import React from 'react'

export const Spinner = ({
  color,
  size,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & SpinnerVariantProps) => {
  const { t } = useTranslate()
  return (
    <div
      title={t('shared.loading')}
      className={spinnerVariants({ color, size, className })}
      {...props}
    />
  )
}
type SpinnerVariantProps = VariantProps<typeof spinnerVariants>
const spinnerVariants = cva('animate-spin rounded-full', {
  variants: {
    color: {
      white: 'border-white/15 border-r-white/85',
      black: 'border-black/15 border-r-black/85',
      green: 'border-r-success-300',
    },
    size: {
      xs: 'size-4 border-2',
      sm: 'size-5 border-2',
      md: 'size-10 border-4',
      auto: '',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
